import React, { Component } from "react";
import { Button, Modal, FormControl, FormGroup } from "react-bootstrap";
import { fire, auth } from "../../firebase/index";
import {
  customLog,
  deploymentEnvironment,
  style,
} from "../../variables/Variables";
import ReactGA from "react-ga";
import RedemptionSample from "../Tutorial/RedemptionSample";
import LocalizedStrings from "react-localization";
import TimeStamp from "react-timestamp";
import NotificationSystem from "react-notification-system";
import Loading from "../../components/Loading/Loading";
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import SubscribePlan from "../Tutorial/SubscribePlanGuide";
let localizationStrings = new LocalizedStrings({
  en: {
    redemptionTitle:
      "The following eGeeTouch Account will be used for redemption",
    accountName: "Account Name",
    accountEmail: "Account Email",
    accountCompany: "Account Company",
    enterRedemption: "Enter Product Key",
    warningText:
      " If the above email is incorrect, please sign out and redeem using the correct eGeeTouch Account",
    validateCode: "Validate Code",
    disableCode: "Disable Code",
    redeem: "Redeem",
    learnMore: "Learn more about Product Keys and see examples",
    noRedemptionMessage:
      "*No Product Key? Select the Subscription Plans' tab above to continue with alternative subscription methods",
    popupWarning: "Warning",
    userExists: "User account already exists, do you want to remove?",
    removeBtn: "Remove",
    cancelBtn: "Cancel",
    modalHeader: "Redeem or Subscribe a Plan",
  },
  ja: {
    redemptionTitle:
      "eGeeTouchインテリジェントアクセス管理システム用アカウント",
    accountName: "アカウント名",
    accountEmail: "アカウントEメール",
    accountCompany: "企業名・グループ名等",
    enterRedemption: "16桁のプロダクトキーを入力",
    warningText:
      " メールアドレスを誤って入力した場合は、サインアウトしてから、正しいアドレスを入力してください。",
    validateCode: "プロダクトキーの検証",
    disableCode: "無効にする",
    redeem: "申込み",
    learnMore: "プロダクトキーについて",
    noRedemptionMessage:
      "プロダクトキーをお持ちでない場合、「サブスクリプション」からクレジットカード決済でお申込みできます。",
    popupWarning: "メッセージ",
    userExists: "メンバーのアカウントは現在有効です。無効にしますか？",
    removeBtn: "無効にする",
    cancelBtn: "キャンセル",
    modalHeader: "プラン選択・ご契約",
  },
  es: {
    redemptionTitle:
      "La siguiente cuenta de eGeeTouch se utilizará para el canje",
    accountName: "Nombre de la Cuenta",
    accountEmail: "Correo Electrónico de la Cuenta",
    accountCompany: "Empresa de la Cuenta",
    enterRedemption: "Ingrese la Clave del Producto",
    warningText:
      "Si el correo electrónico anterior es incorrecto, cierre sesión y canjee utilizando la cuenta correcta de eGeeTouch",
    validateCode: "Validar Código",
    disableCode: "Deshabilitar Código",
    redeem: "Canjear",
    learnMore: "Aprenda más sobre las Claves de Producto y vea ejemplos",
    noRedemptionMessage:
      "*¿No tiene Clave de Producto? Seleccione la pestaña de Planes de Suscripción arriba para continuar con métodos alternativos de suscripción",
    popupWarning: "Advertencia",
    userExists: "La cuenta de usuario ya existe, ¿desea eliminarla?",
    removeBtn: "Eliminar",
    cancelBtn: "Cancelar",
    modalHeader: "Canjear o Suscribirse a un Plan",
  },
});

var trackerID = "";
if (deploymentEnvironment) {
  //! Live
  trackerID = "G-7D4M74VB11";
} else {
  //! Test
  trackerID = "G-LWK1V2E1FE";
}

//VERSION 1 -> ORIGINAL VERSION

class Redemption extends Component {
  constructor(props) {
    super(props);

    // console.log("Checking for redemption page");
    this.state = {
      activeRedemption: true,
      freeUser: false,
      newUser: false,
      existingAccount: false,
      existingSuperAdminStatus: false,
      userDetail: [],
      inputRedemptionCode1: "",
      inputRedemptionCode2: "",
      inputRedemptionCode3: "",
      inputRedemptionCode4: "",
      redemptionPackage: [],
      validateCodePackage: {},
      redemptionCodeExist: false,
      redemptionCodeValidation: false,
      redemptionCode: "",
      redeemedBefore: false,
      specialCodeUsed: false,
      _notificationSystem: null,
      validationMessageCode: "",
      showPopup: false,
      popupTitle: "",
      popupImage: [],
      currentLanguage: "",
    };

    this.handleInputCode1 = this.handleInputCode1.bind(this);
    this.handleInputCode2 = this.handleInputCode2.bind(this);
    this.handleInputCode3 = this.handleInputCode3.bind(this);
    this.handleInputCode4 = this.handleInputCode4.bind(this);
    this.validateCode = this.validateCode.bind(this);
    this.disableCode = this.disableCode.bind(this);
    this.redeemCode = this.redeemCode.bind(this);
    this.toInputUppercase = this.toInputUppercase.bind(this);
    this.showNotification = this.showNotification.bind(this);
    this.handleValidationMessage = this.handleValidationMessage.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.handleWarningRemoveBtn = this.handleWarningRemoveBtn.bind(this);
    this.handleWarningPopupOpen = this.handleWarningPopupOpen.bind(this);
    this.handleWarningPopupClose = this.handleWarningPopupClose.bind(this);
    this.checkExistingAccount = this.checkExistingAccount.bind(this);

    this.textInput1 = React.createRef();
    this.textInput2 = React.createRef();
    this.textInput3 = React.createRef();
    this.textInput4 = React.createRef();
  }
  componentWillMount() {
    // check for existing account
    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        snapshot.forEach((user) => {
          let userId = user.key;

          fire
            .database()
            .ref("groupAccounts")
            .child(userId)
            .child("members")
            .once("value")
            .then((childSnapshot) => {
              childSnapshot.forEach((member) => {
                let memberVal = member.val();
                if (memberVal.memberEmail === auth.currentUser.email) {
                  if (memberVal.isSuperAdmin === true) {
                    this.setState({
                      existingSuperAdminStatus: true,
                      existingAccount: true,
                    });
                  } else {
                    this.setState({ existingAccount: true });
                  }

                  if (user.val().payment.currentPaymentType === "") {
                    this.setState({
                      freeUser: true,
                    });
                  }

                  if (user.val().payment.currentRedemptionActiveCode === "") {
                    this.setState({
                      activeRedemption: false,
                    });
                  }
                }
              });
            });
        });
      });

    fire
      .database()
      .ref("groupAccounts")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          //  console.log("Hello snap exist !!")
          if (snapshot.val().payment.currentPaymentType === "") {
            this.setState({
              freeUser: true,
            });
          }

          if (snapshot.val().payment.currentRedemptionActiveCode === "") {
            this.setState({
              activeRedemption: false,
            });
          }
        } else {
          // console.log("Hello snap doesn't exist !!")
          this.setState({
            newUser: true,
          });
        }
      });

    //  fire
    //                   .database()
    //                   .ref("redeemedRedemptionCodes")
    //                   .child("SPECIAL_ONE_YEAR")
    //                   .child(inputRedemptionCode)
    //                   .orderByChild("redeemedUid")
    //                   .equalTo(auth.currentUser.uid)
    //                   .once("value")
    //                   .then(snapshot => {
    //                     if(snapshot.exists()) {
    //                       this.setState({
    //                         redeemedBefore: true
    //                       });
    //                       // console.log("Query Redeemed: True");
    //                     }
    //                   })

    fire
      .database()
      .ref("registeredIndustrialUsersOnPlatform")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        this.setState({
          userDetail: snapshot.val(),
        });
      })
      .then(() => {
        customLog(this.state.userDetail);
      });

    //! FOR LANGUAGE
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }

    fire
      .database()
      .ref("redeemedRedemptionCodes")
      .child("SPECIAL_ONE_YEAR")
      .once("value")
      .then((snapshot) => {
        snapshot.forEach((code) => {
          code.forEach((user) => {
            if (user.val().redeemedUid === auth.currentUser.uid) {
              //if its one of the two codes that are available now
              if (
                user.val().redemptionCode === "STYR986215772678" ||
                user.val().redemptionCode === "SPYR982873341729"
              ) {
                this.setState({
                  specialCodeUsed: true,
                });
              }
            }
          });
        });
      });
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  showNotification(msg, lvl, dismissal, allowDismiss) {
    let dismissalAllowed = false;

    if (allowDismiss === "") {
      dismissalAllowed = true;
    }
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell"></span>,
      message: <div>{msg}</div>,
      level: lvl,
      position: "tc",
      autoDismiss: dismissal,
      dismissible: dismissalAllowed,
    });
  }

  toInputUppercase = (e) => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };

  handleInputCode1(code, field) {
    if (code.target.value.length === 4) {
      field.current.nextSibling.nextSibling.focus();
      this.setState({
        inputRedemptionCode1: code.target.value,
      });
    }
  }
  handleInputCode2(code, field) {
    if (code.target.value.length === 4) {
      field.current.nextSibling.nextSibling.focus();
      this.setState({
        inputRedemptionCode2: code.target.value,
      });
    }
  }
  handleInputCode3(code, field) {
    if (code.target.value.length === 4) {
      field.current.nextSibling.nextSibling.focus();
      this.setState({
        inputRedemptionCode3: code.target.value,
      });
    }
  }
  handleInputCode4(code, field) {
    if (code.target.value.length === 4) {
      this.setState({
        inputRedemptionCode4: code.target.value,
      });
    }
  }

  validateCode(e) {
    e.preventDefault();

    ReactGA.event(
      {
        category: "plan subscription",
        action: "enter plan subscription page",
        value: 1,
      },
      [trackerID]
    );

    const inputRedemptionCode =
      this.state.inputRedemptionCode1 +
      this.state.inputRedemptionCode2 +
      this.state.inputRedemptionCode3 +
      this.state.inputRedemptionCode4;
    customLog("INPUT CODE (" + inputRedemptionCode + ")");

    var BreakException = {};

    try {
      fire
        .database()
        .ref("redemptionCodes")
        .once("value")
        .then((snapshot) => {
          let redemptionPlanDetail = {};
          snapshot.forEach((redemptionCodes) => {
            redemptionCodes.forEach((eachCode) => {
              if (inputRedemptionCode !== "") {
                if (
                  inputRedemptionCode === eachCode.key &&
                  eachCode.val().redemptionCodesEnabled === true
                ) {
                  if (
                    eachCode.val().redeemed !== true ||
                    eachCode.val().isMultiUserCode === true
                  ) {
                    if (eachCode.val().isSpecialCode) {
                      if (eachCode.val().Plan === 1) {
                        redemptionPlanDetail = {
                          package: "STARTER",
                          plan: 1,
                          maxLocks: eachCode.val().maxLocks,
                          maxTags: eachCode.val().maxTags,
                          maxUsers: eachCode.val().maxUsers,
                          maxMulti: eachCode.val().maxMulti,
                          special: true,
                        };
                      } else if (eachCode.val().Plan === 5) {
                        redemptionPlanDetail = {
                          package: "STARTER PLUS",
                          plan: 5,
                          maxLocks: eachCode.val().maxLocks,
                          maxTags: eachCode.val().maxTags,
                          maxUsers: eachCode.val().maxUsers,
                          maxMulti: eachCode.val().maxMulti,
                          special: true,
                        };
                      }
                    } else if (eachCode.val().Plan === 1) {
                      redemptionPlanDetail = {
                        package: "STARTER",
                        plan: 1,
                        maxLocks: 50,
                        maxTags: 500,
                        maxUsers: 20,
                        maxMulti: 4,
                      };
                    } else if (eachCode.val().Plan === 2) {
                      redemptionPlanDetail = {
                        package: "ESSENTIAL",
                        plan: 2,
                        maxLocks: 100,
                        maxTags: 500,
                        maxUsers: 40,
                        maxMulti: 4,
                      };
                    } else if (eachCode.val().Plan === 3) {
                      redemptionPlanDetail = {
                        package: "PROFESSIONAL",
                        plan: 3,
                        maxLocks: 500,
                        maxTags: 500,
                        maxUsers: 100,
                        maxMulti: 8,
                      };
                    } else if (eachCode.val().Plan === 4) {
                      redemptionPlanDetail = {
                        package: "CUSTOM",
                        plan: 4,
                        maxLocks: eachCode.val().maxLocks,
                        maxTags: eachCode.val().maxTags,
                        maxUsers: eachCode.val().maxUsers,
                        maxMulti: eachCode.val().maxMulti,
                      };
                    } else if (eachCode.val().Plan === 6) {
                      redemptionPlanDetail = {
                        package: "ENTRY_STARTER",
                        plan: 6,
                        maxLocks: 5,
                        maxTags: 4,
                        maxUsers: 4,
                        maxMulti: 1,
                      };
                    } else if (eachCode.val().Plan === 7) {
                      redemptionPlanDetail = {
                        package: "LOCK_FOCUS",
                        plan: 7,
                        maxLocks: 25,
                        maxTags: 10,
                        maxUsers: 10,
                        maxMulti: 2,
                      };
                    } else if (eachCode.val().Plan === 8) {
                      redemptionPlanDetail = {
                        package: "PRO_LOCK",
                        plan: 8,
                        maxLocks: 300,
                        maxTags: 75,
                        maxUsers: 25,
                        maxMulti: 4,
                      };
                    } else if (eachCode.val().Plan === 9) {
                      redemptionPlanDetail = {
                        package: "USER_FOCUS",
                        plan: 9,
                        maxLocks: 4,
                        maxTags: 30,
                        maxUsers: 40,
                        maxMulti: 2,
                      };
                    } else if (eachCode.val().Plan === 10) {
                      redemptionPlanDetail = {
                        package: "PRO_USER",
                        plan: 10,
                        maxLocks: 10,
                        maxTags: 100,
                        maxUsers: 180,
                        maxMulti: 4,
                      };
                    }

                    if (eachCode.val().isSpecialCode === true) {
                      // check if redeemed before

                      // //Change to query?
                      fire
                        .database()
                        .ref("redeemedRedemptionCodes")
                        .child("SPECIAL_ONE_YEAR")
                        .child(inputRedemptionCode)
                        .orderByChild("redeemedUid")
                        .equalTo(auth.currentUser.uid)
                        .once("value")
                        .then((snapshot) => {
                          if (snapshot.exists()) {
                            this.setState({
                              redeemedBefore: true,
                            });
                            // console.log("Query Redeemed: True");
                          }
                        });

                      //test
                      // fire
                      //   .database()
                      //   .ref("redeemedRedemptionCodes")
                      //   .child("SPECIAL_ONE_YEAR")
                      //   .child(inputRedemptionCode)
                      //   .child(auth.currentUser.uid)
                      //   .once("value")
                      //   .then(snapshot => {
                      //     if(snapshot.exists()){
                      //       if(snapshot.val().redeemedUid === auth.currentUser.uid) {
                      //         this.setState({
                      //           redeemedBefore: true
                      //         });
                      //         // console.log("Test Redeemed: True");
                      //       }
                      //     }
                      //   })
                    }

                    this.setState({
                      redemptionPackage: eachCode.val(),
                      validateCodePackage: redemptionPlanDetail,
                      redemptionCodeExist: true,
                      redemptionCode: inputRedemptionCode,
                      validationMessageCode: 1,
                    });
                    throw BreakException;
                  } else {
                    this.setState({
                      validationMessageCode: 3,
                      redemptionCodeExist: false,
                    });
                  }
                } else {
                  this.setState({
                    validationMessageCode: 2,
                    redemptionCodeExist: false,
                  });
                }
              } else {
                this.setState({
                  validationMessageCode: 4,
                  redemptionCodeExist: false,
                });
              }
            });
          });
        })
        .then(() => {
          customLog(this.state.redemptionPackage);
          customLog(this.state.validateCodePackage);
        });
    } catch (e) {
      if (e !== BreakException) {
        throw e;
      }
    }
  }

  disableCode(e) {
    e.preventDefault();

    ReactGA.event(
      {
        category: "plan subscription",
        action: "enter plan subscription page",
        value: 1,
      },
      [trackerID]
    );

    const inputRedemptionCode =
      this.state.inputRedemptionCode1 +
      this.state.inputRedemptionCode2 +
      this.state.inputRedemptionCode3 +
      this.state.inputRedemptionCode4;
    customLog("INPUT CODE (" + inputRedemptionCode + ")");

    fire
      .database()
      .ref("groupAccounts")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          //  console.log("Hello snap exist !!")
          if (snapshot.val().payment.currentPaymentType === "") {
            this.setState({
              freeUser: true,
            });
          }

          if (snapshot.val().payment.currentRedemptionActiveCode === "") {
            this.setState({
              activeRedemption: false,
            });
          }
        } else {
          // console.log("Hello snap doesn't exist !!")
          this.setState({
            newUser: true,
          });
        }
      });

    var BreakException = {};

    try {
      const redemptionCodesRef = fire
        .database()
        .ref("redemptionCodes")
        .child("CUSTOM")
        .child(inputRedemptionCode);

      redemptionCodesRef.once("value").then((snapshot) => {
        const redemptionCode = snapshot.val();
        if (redemptionCode !== null && inputRedemptionCode === snapshot.key) {
          redemptionCodesRef.update({
            redemptionCodesEnabled: false,
          });
        } else {
          // console.log("Redemption code does not exist in database");
        }
      });
    } catch (e) {
      if (e !== BreakException) {
        throw e;
      }
    }

    try {
      const redemptionCodesRef = fire
        .database()
        .ref("redemptionCodes")
        .child("ESSENTIAL")
        .child(inputRedemptionCode);

      redemptionCodesRef.once("value").then((snapshot) => {
        const redemptionCode = snapshot.val();
        if (redemptionCode !== null && inputRedemptionCode === snapshot.key) {
          redemptionCodesRef.update({
            redemptionCodesEnabled: false,
          });
        } else {
          // console.log("Redemption code does not exist in database");
        }
      });
    } catch (e) {
      if (e !== BreakException) {
        throw e;
      }
    }

    try {
      const redemptionCodesRef = fire
        .database()
        .ref("redemptionCodes")
        .child("PROFESSIONAL")
        .child(inputRedemptionCode);

      redemptionCodesRef.once("value").then((snapshot) => {
        const redemptionCode = snapshot.val();
        if (redemptionCode !== null && inputRedemptionCode === snapshot.key) {
          redemptionCodesRef.update({
            redemptionCodesEnabled: false,
          });
        } else {
          // console.log("Redemption code does not exist in database");
        }
      });
    } catch (e) {
      if (e !== BreakException) {
        throw e;
      }
    }

    try {
      const redemptionCodesRef = fire
        .database()
        .ref("redemptionCodes")
        .child("SPECIAL_ONE_YEAR")
        .child(inputRedemptionCode);

      redemptionCodesRef.once("value").then((snapshot) => {
        const redemptionCode = snapshot.val();
        if (redemptionCode !== null && inputRedemptionCode === snapshot.key) {
          redemptionCodesRef.update({
            redemptionCodesEnabled: false,
          });
        } else {
          // console.log("Redemption code does not exist in database");
        }
      });
    } catch (e) {
      if (e !== BreakException) {
        throw e;
      }
    }

    try {
      const redemptionCodesRef = fire
        .database()
        .ref("redemptionCodes")
        .child("STARTER")
        .child(inputRedemptionCode);

      redemptionCodesRef.once("value").then((snapshot) => {
        const redemptionCode = snapshot.val();
        if (redemptionCode !== null && inputRedemptionCode === snapshot.key) {
          redemptionCodesRef.update({
            redemptionCodesEnabled: false,
          });
        } else {
          // console.log("Redemption code does not exist in database");
        }
      });
    } catch (e) {
      if (e !== BreakException) {
        throw e;
      }
    }

    try {
      const redemptionCodesRef = fire
        .database()
        .ref("redemptionCodes")
        .child("STARTER PLUS")
        .child(inputRedemptionCode);

      redemptionCodesRef.once("value").then((snapshot) => {
        const redemptionCode = snapshot.val();
        if (redemptionCode !== null && inputRedemptionCode === snapshot.key) {
          redemptionCodesRef.update({
            redemptionCodesEnabled: false,
          });
        } else {
          // console.log("Redemption code does not exist in database");
        }
      });
    } catch (e) {
      if (e !== BreakException) {
        throw e;
      }
    }
  }

  checkExistingAccount() {
    if (this.state.existingAccount) {
      if (this.state.existingSuperAdminStatus) {
        this.redeemCode();
      } else {
        this.setState({ showWarning: true });
      }
    } else {
      this.redeemCode();
    }
  }

  redeemCode() {
    const codeExist = this.state.redemptionCodeExist;
    const validCode = this.state.redemptionCode;
    const validCodePackagePlan = this.state.validateCodePackage.package;
    const isSpecialCode = this.state.validateCodePackage.special;
    const validCodePackageDetail = this.state.validateCodePackage;
    var formattedValidCode = validCode.substring(0, 4);

    let url = "";
    const dataToPost = {
      packageName: validCodePackagePlan,
      redemptionCode: formattedValidCode,
      uid: auth.currentUser.uid,
      email: auth.currentUser.email,
      language: this.state.currentLanguage,
    };

    if (codeExist) {
      // fire
      //   .database()
      //   .ref("redemptionCodes")
      //   .child(validCodePackage)
      //   .child(validCode)
      //   .once("value")
      //   .then(snapshot => {
      //     console.log(snapshot.val());
      //   });

      //24*60*60 = 86400 (1 day)
      const oneYearInSecond = 31536000;
      const redeemedDate = Math.floor(Date.now() / 1000);
      const redemptionEndDate = redeemedDate + oneYearInSecond;

      //Check if user has not used the special code before
      if (this.state.redeemedBefore === false) {
        if (isSpecialCode) {
          //check if user has redeemed a special code before
          if (this.state.specialCodeUsed === false) {
            //if the user has not redeemed before:
            customLog(
              "Hello Checking activeRedemption : " +
                this.state.activeRedemption +
                " FreeUser: " +
                this.state.freeUser
            );
            if (
              this.state.activeRedemption === false ||
              this.state.freeUser === true ||
              this.state.newUser === true
            ) {
              fire
                .database()
                .ref("redemptionCodes")
                .child("SPECIAL_ONE_YEAR")
                .child(validCode)
                .update({
                  lastRedeemptionTime: redeemedDate,
                  redeemed: true,
                });

              //! UPDATE redeemedRedemptionCodes Done
              fire
                .database()
                .ref("redeemedRedemptionCodes")
                .child("SPECIAL_ONE_YEAR")
                .child(validCode)
                .child(auth.currentUser.uid)
                .update({
                  currentActive: true,
                  redemptionCode: validCode,
                  redeemedStartDate: redeemedDate,
                  redeemedEmail: auth.currentUser.email,
                  redeemedUid: auth.currentUser.uid,
                });

              //! UPDATE groupAccounts payment
              //! Check if user groupAccount exist or not

              let groupAccountDB = fire
                .database()
                .ref("groupAccounts")
                .child(auth.currentUser.uid);

              const pushKey = groupAccountDB
                .child("payment")
                .child("redeemedRedemptionCode")
                .push().key;

              const dbPayments = {
                isPaymentValid: true,
                maxUsers: validCodePackageDetail.maxUsers,
                maxTags: validCodePackageDetail.maxTags,
                maxLocks: validCodePackageDetail.maxLocks,
                maxMulti: validCodePackageDetail.maxMulti,
                plan: validCodePackageDetail.plan,
                currentPaymentType: "REDEMPTION",
                currentRedemptionActiveCode: validCode,
                startedOn: redeemedDate,
                endedOn: redemptionEndDate,
              };

              const dbGroupMembers = {
                isAdmin: true,
                isSuperAdmin: true,
                memberAddedOn: redeemedDate,
                memberEmail: auth.currentUser.email,
                memberUid: "push.key",
              };

              const groupAccSchema = {
                created_on: redeemedDate,
                groupName: "My First Group",
                payment: dbPayments,
              };

              groupAccountDB
                .once("value")
                .then((snapshot) => {
                  //! if groupAccount exist
                  if (snapshot.exists()) {
                    customLog("Redemption: Existing User");
                    if (
                      snapshot.val().payment.redeemedRedemptionCode === null ||
                      snapshot.val().payment.redeemedRedemptionCode ===
                        undefined
                    ) {
                      customLog(
                        "Redemption: Existing User but NEVER REDEEM BEFORE"
                      );
                      //! existing user but NEVER REDEEM BEFORE

                      groupAccountDB
                        .child("payment")
                        .update({
                          isPaymentValid: true,
                          maxUsers: validCodePackageDetail.maxUsers,
                          maxTags: validCodePackageDetail.maxTags,
                          maxLocks: validCodePackageDetail.maxLocks,
                          maxMulti: validCodePackageDetail.maxMulti,
                          plan: validCodePackageDetail.plan,
                          currentPaymentType: "REDEMPTION",
                          currentRedemptionActiveCode: validCode,
                          endedOn: redemptionEndDate,
                          specialTrialMode: false,
                          onTrialPeriod: false,
                        })
                        .then(async () => {
                          await groupAccountDB
                            .child(
                              "payment/" + "redeemedRedemptionCode/" + pushKey
                            )
                            .update({
                              redemptionCode: validCode,
                              redeemedEndTime: redemptionEndDate,
                              redeemedStartTime: redeemedDate,
                              maxUsers: validCodePackageDetail.maxUsers,
                              maxTags: validCodePackageDetail.maxTags,
                              maxLocks: validCodePackageDetail.maxLocks,
                              maxMulti: validCodePackageDetail.maxMulti,
                            });
                        });
                    } else {
                      customLog("Redemption: Existing User and REDEEM BEFORE");
                      //! existing user and REDEEM BEFORE

                      groupAccountDB
                        .child("payment")
                        .once("value")
                        .then(async (snapshot) => {
                          const firstEndDateSecondStartDate = snapshot.val()
                            .endedOn;
                          const updateRedemptionEndDate =
                            snapshot.val().endedOn + oneYearInSecond;

                          await groupAccountDB
                            .child("payment")
                            .update({
                              isPaymentValid: true,
                              endedOn: updateRedemptionEndDate,
                              currentPaymentType: "REDEMPTION",
                              specialTrialMode: false,
                              onTrialPeriod: false,
                            })
                            .then(async () => {
                              await groupAccountDB
                                .child(
                                  "payment/" +
                                    "redeemedRedemptionCode/" +
                                    pushKey
                                )
                                .update({
                                  redemptionCode: validCode,
                                  redeemedEndTime: updateRedemptionEndDate,
                                  redeemedStartTime: firstEndDateSecondStartDate,
                                  maxUsers: validCodePackageDetail.maxUsers,
                                  maxTags: validCodePackageDetail.maxTags,
                                  maxLocks: validCodePackageDetail.maxLocks,
                                  maxMulti: validCodePackageDetail.maxMulti,
                                });
                            });
                        });
                    }
                  } //! if free user
                  else {
                    customLog("Redemption: New User");
                    groupAccountDB.set(groupAccSchema).then(async () => {
                      const today = new Date();

                      const groupMembersKey = groupAccountDB
                        .child("members")
                        .push(dbGroupMembers).key;

                      await groupAccountDB
                        .child("members/" + groupMembersKey)
                        .update({
                          memberUid: groupMembersKey,
                          memberEmail: auth.currentUser.email,
                          memberAddedOn: today.getTime(),
                        });

                      const randomKey = groupAccountDB.child("groupID").push()
                        .key;

                      await groupAccountDB.child("groupID").set(randomKey);

                      await groupAccountDB
                        .child("payment/" + "redeemedRedemptionCode/" + pushKey)
                        .update({
                          redemptionCode: validCode,
                          redeemedEndTime: redemptionEndDate,
                          redeemedStartTime: redeemedDate,
                          maxUsers: validCodePackageDetail.maxUsers,
                          maxTags: validCodePackageDetail.maxTags,
                          maxLocks: validCodePackageDetail.maxLocks,
                          maxMulti: validCodePackageDetail.maxMulti,
                        });
                    });
                  }
                })
                .then(async () => {
                  await this.showNotification(
                    "Redeem Redemption Code Successful!",
                    "success",
                    3
                  );
                  //! route to home page
                  await setTimeout(() => {
                    window.location.href = "/dashboard";
                  }, 3000);

                  //! send email after update the database

                  if (deploymentEnvironment) {
                    url =
                      "https://us-central1-egeetouchindustrial.cloudfunctions.net/redeemRedemptionCode";
                    customLog("Live Environment @ redeemRedemptionCode");
                  } else {
                    url =
                      "https://us-central1-egeetouchindustrial.cloudfunctions.net/redeemRedemptionCode";
                    customLog("Test Environment @ redeemRedemptionCode");
                  }
                  let response = await fetch(url, {
                    method: "POST",
                    body: JSON.stringify(dataToPost),
                  });
                  let responseVal = await response.json();
                  customLog(responseVal);
                });
            } else {
              customLog("User is not a new user!");
              this.showNotification(
                "This redemption code is for new users or users without an active redemption code!",
                "error",
                3
              );
            }
          } else {
            customLog("User redeemed special code before!");
            this.showNotification(
              "Unable to redeem as you have already used a special code!",
              "error",
              3
            );
          }
        } else {
          //! UPDATE redemptionCodes Done
          fire
            .database()
            .ref("redemptionCodes")
            .child(validCodePackagePlan)
            .child(validCode)
            .update({
              redeemed: true,
              redeemedDate: redeemedDate,
              email: auth.currentUser.email,
              redeemedUid: auth.currentUser.uid,
            });

          //! UPDATE redeemedRedemptionCodes Done
          fire
            .database()
            .ref("redeemedRedemptionCodes")
            .child(validCodePackagePlan)
            .child(validCode)
            .update({
              currentActive: true,
              redemptionCode: validCode,
              redeemedStartDate: redeemedDate,
              redeemedEmail: auth.currentUser.email,
              redeemedUid: auth.currentUser.uid,
            });

          //! UPDATE groupAccounts payment
          //! Check if user groupAccount exist or not

          let groupAccountDB = fire
            .database()
            .ref("groupAccounts")
            .child(auth.currentUser.uid);

          const pushKey = groupAccountDB
            .child("payment")
            .child("redeemedRedemptionCode")
            .push().key;

          const dbPayments = {
            isPaymentValid: true,
            maxUsers: validCodePackageDetail.maxUsers,
            maxTags: validCodePackageDetail.maxTags,
            maxLocks: validCodePackageDetail.maxLocks,
            maxMulti: validCodePackageDetail.maxMulti,
            plan: validCodePackageDetail.plan,
            currentPaymentType: "REDEMPTION",
            currentRedemptionActiveCode: validCode,
            startedOn: redeemedDate,
            endedOn: redemptionEndDate,
          };

          const dbGroupMembers = {
            isAdmin: true,
            isSuperAdmin: true,
            memberAddedOn: redeemedDate,
            memberEmail: auth.currentUser.email,
            memberUid: "push.key",
          };

          const groupAccSchema = {
            created_on: redeemedDate,
            groupName: "My First Group",
            payment: dbPayments,
          };

          groupAccountDB
            .once("value")
            .then((snapshot) => {
              //! if groupAccount exist
              if (snapshot.exists()) {
                customLog("Redemption: Existing User");
                if (
                  snapshot.val().payment.redeemedRedemptionCode === null ||
                  snapshot.val().payment.redeemedRedemptionCode === undefined
                ) {
                  customLog(
                    "Redemption: Existing User but NEVER REDEEM BEFORE"
                  );
                  //! existing user but NEVER REDEEM BEFORE

                  groupAccountDB
                    .child("payment")
                    .update({
                      isPaymentValid: true,
                      maxUsers: validCodePackageDetail.maxUsers,
                      maxTags: validCodePackageDetail.maxTags,
                      maxLocks: validCodePackageDetail.maxLocks,
                      maxMulti: validCodePackageDetail.maxMulti,
                      plan: validCodePackageDetail.plan,
                      currentPaymentType: "REDEMPTION",
                      currentRedemptionActiveCode: validCode,
                      endedOn: redemptionEndDate,
                      specialTrialMode: false,
                    })
                    .then(async () => {
                      await groupAccountDB
                        .child("payment/" + "redeemedRedemptionCode/" + pushKey)
                        .update({
                          redemptionCode: validCode,
                          redeemedEndTime: redemptionEndDate,
                          redeemedStartTime: redeemedDate,
                          maxUsers: validCodePackageDetail.maxUsers,
                          maxTags: validCodePackageDetail.maxTags,
                          maxLocks: validCodePackageDetail.maxLocks,
                          maxMulti: validCodePackageDetail.maxMulti,
                        });
                    });
                } else {
                  customLog("Redemption: Existing User and REDEEM BEFORE");
                  //! existing user and REDEEM BEFORE

                  groupAccountDB
                    .child("payment")
                    .once("value")
                    .then(async (snapshot) => {
                      const firstEndDateSecondStartDate = snapshot.val()
                        .endedOn;
                      const updateRedemptionEndDate =
                        snapshot.val().endedOn + oneYearInSecond;

                      await groupAccountDB
                        .child("payment")
                        .update({
                          isPaymentValid: true,
                          endedOn: updateRedemptionEndDate,
                        })
                        .then(async () => {
                          await groupAccountDB
                            .child(
                              "payment/" + "redeemedRedemptionCode/" + pushKey
                            )
                            .update({
                              redemptionCode: validCode,
                              redeemedEndTime: updateRedemptionEndDate,
                              redeemedStartTime: firstEndDateSecondStartDate,
                              maxUsers: validCodePackageDetail.maxUsers,
                              maxTags: validCodePackageDetail.maxTags,
                              maxLocks: validCodePackageDetail.maxLocks,
                              maxMulti: validCodePackageDetail.maxMulti,
                            });
                        });
                    });
                }
              } //! if new user
              else {
                customLog("Redemption: New User");
                groupAccountDB.set(groupAccSchema).then(async () => {
                  const today = new Date();

                  const groupMembersKey = groupAccountDB
                    .child("members")
                    .push(dbGroupMembers).key;

                  await groupAccountDB
                    .child("members/" + groupMembersKey)
                    .update({
                      memberUid: groupMembersKey,
                      memberEmail: auth.currentUser.email,
                      memberAddedOn: today.getTime(),
                    });

                  const randomKey = groupAccountDB.child("groupID").push().key;

                  await groupAccountDB.child("groupID").set(randomKey);

                  await groupAccountDB
                    .child("payment/" + "redeemedRedemptionCode/" + pushKey)
                    .update({
                      redemptionCode: validCode,
                      redeemedEndTime: redemptionEndDate,
                      redeemedStartTime: redeemedDate,
                      maxUsers: validCodePackageDetail.maxUsers,
                      maxTags: validCodePackageDetail.maxTags,
                      maxLocks: validCodePackageDetail.maxLocks,
                      maxMulti: validCodePackageDetail.maxMulti,
                    });
                });
              }
            })
            .then(async () => {
              await this.showNotification(
                "Redeem Redemption Code Successful!",
                "success",
                3
              );
              //! route to home page
              await setTimeout(() => {
                window.location.href = "/dashboard";
              }, 3000);

              //! send email after update the database

              if (deploymentEnvironment) {
                url =
                  "https://us-central1-egeetouchindustrial.cloudfunctions.net/redeemRedemptionCode";
                customLog("Live Environment @ redeemRedemptionCode");
              } else {
                url =
                  "https://us-central1-egeetouchindustrial.cloudfunctions.net/redeemRedemptionCode";
                customLog("Test Environment @ redeemRedemptionCode");
              }
              let response = await fetch(url, {
                method: "POST",
                body: JSON.stringify(dataToPost),
              });
              let responseVal = await response.json();
              customLog(responseVal);
            });
        }
      } else {
        customLog("Code Has Been Used Before!");
        this.showNotification(
          "You have previously used this code. Try a different one!",
          "error",
          3
        );
      }
    } else {
      customLog("Code Do Not Exist!");
      this.showNotification(
        "The redemption code you entered is invalid. Please try again.",
        "error",
        3
      );
    }
  }

  handleValidationMessage(messageNumber) {
    if (messageNumber === 1) {
      return "The code you entered is valid for redeem.";
    } else if (messageNumber === 2) {
      return "There is a problem with that code or the code you typed is expired. Try a different one.";
    } else if (messageNumber === 3) {
      return "The code you entered has already been redeemed by someone else.";
    } else if (messageNumber === 4) {
      return "Please enter your redemption code.";
    } else {
      return "";
    }
  }

  handleWarningRemoveBtn() {
    //delete user info in groupAccounts member list
    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        snapshot.forEach((user) => {
          let userId = user.key;

          fire
            .database()
            .ref("groupAccounts")
            .child(userId)
            .child("members")
            .once("value")
            .then((childSnapshot) => {
              childSnapshot.forEach((member) => {
                let memberVal = member.val();
                if (memberVal.memberEmail === auth.currentUser.email) {
                  let memberUid = memberVal.memberUid;
                  //delete
                  fire
                    .database()
                    .ref("groupAccounts")
                    .child(userId)
                    .child("members")
                    .child(memberUid)
                    .remove();

                  this.setState({
                    open: true,
                    showWarning: false,
                    existingAccount: false,
                  });
                }
              });
            });
        });
      });

    // delete user info in userLocks
    fire
      .database()
      .ref("userLocks")
      .child(auth.currentUser.uid)
      .remove();

    // delete user info in retractableSharingRegistry
    fire
      .database()
      .ref("retractableSharingRegistry")
      .child(auth.currentUser.uid)
      .remove();

    // delete user info in MyAdminLocks
    fire
      .database()
      .ref("MyAdminLocks")
      .child(auth.currentUser.uid)
      .remove();

    // delete user info in MyShareHistory
    fire
      .database()
      .ref("MyShareHistory")
      .child(auth.currentUser.uid)
      .remove();

    // delete user info in userFriendListIndustrial
    fire
      .database()
      .ref("userFriendListIndustrial")
      .child(auth.currentUser.uid)
      .remove();

    this.redeemCode();
  }

  handlePopupOpen() {
    this.setState({
      showPopup: true,
      popupTitle: localizationStrings.modalHeader,
      popupImage: [<SubscribePlan />],
    });
  }

  handlePopupClose() {
    this.setState({ showPopup: false });
  }

  handleWarningPopupOpen() {
    this.setState({ showWarning: true });
  }

  handleWarningPopupClose() {
    this.setState({ showWarning: false });
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }
    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        <Modal
          show={this.state.showWarning}
          onHide={this.handleWarningPopupClose}
          dialogClassName="modal-fixed-400px"
          style={{ display: "flex", alignItems: "center" }}
        >
          <Modal.Header closeButton>
            {/* <Modal.Title><span style={{color: "#3C3E41", fontSize: "20px", marginRight: "10px"}} className="glyphicon glyphicon-alert" aria-hidden="true" /><span style={{ color: "red" }}>{"Warning"}</span></Modal.Title> */}
            <Modal.Title>
              <span style={{ color: "red" }}>
                {localizationStrings.popupWarning}
              </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <p
                className="boldFont"
                style={{
                  textAlign: "left",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                }}
              >
                {localizationStrings.userExists}
              </p>
            </div>
            <br />
            <div style={{ display: "flex", justifyContent: "right" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "60%",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  marginLeft: "auto",
                  marginRight: "0px",
                }}
              >
                <Button
                  className={"toggleAuthBtn colorRed"}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={this.handleWarningRemoveBtn}
                >
                  {localizationStrings.removeBtn}
                </Button>
                <Button
                  className="toggleAuthCancelBtn"
                  onClick={this.handleWarningPopupClose}
                >
                  {localizationStrings.cancelBtn}
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <h3>{localizationStrings.redemptionTitle}</h3>
        <br />
        <table className="redeemPageTable">
          <tbody>
            <tr>
              <th>{localizationStrings.accountName}:</th>
              <th>{this.state.userDetail.name}</th>
            </tr>
            <tr>
              <th>{localizationStrings.accountEmail}:</th>
              <th>{this.state.userDetail.email}</th>
            </tr>
            <tr>
              <th>{localizationStrings.accountCompany}:</th>
              <th>{this.state.userDetail.company}</th>
            </tr>
          </tbody>
        </table>
        <br />
        <h5>{localizationStrings.warningText}</h5>

        <p>
          <a href="#" onClick={this.handlePopupOpen}>
            <u>{localizationStrings.learnMore}</u>
          </a>
        </p>
        <b>{localizationStrings.enterRedemption}</b>

        <form>
          <div className="flex" class="redemptionCodeInput">
            <div className="flex">
              <input
                className="redeemCodeInput"
                name={this.textInput1}
                ref={this.textInput1}
                maxLength="4"
                onChange={(e) => this.handleInputCode1(e, this.textInput1)}
                onInput={this.toInputUppercase}
                placeholder="XXXX"
              />
              <div className="horizontalShortLine"></div>
              <input
                className="redeemCodeInput"
                name={this.textInput2}
                ref={this.textInput2}
                maxLength="4"
                onChange={(e) => this.handleInputCode2(e, this.textInput2)}
                onInput={this.toInputUppercase}
                placeholder="XXXX"
              />
              <div className="horizontalShortLine"></div>
              <input
                className="redeemCodeInput"
                name={this.textInput3}
                ref={this.textInput3}
                maxLength="4"
                onChange={(e) => this.handleInputCode3(e, this.textInput3)}
                onInput={this.toInputUppercase}
                placeholder="XXXX"
              />
              <div className="horizontalShortLine"></div>
              <input
                className="redeemCodeInput"
                name={this.textInput4}
                ref={this.textInput4}
                maxLength="4"
                onChange={(e) => this.handleInputCode4(e, this.textInput4)}
                onInput={this.toInputUppercase}
                placeholder="XXXX"
              />
              <button className="validateBtn" onClick={this.validateCode}>
                {localizationStrings.validateCode}
              </button>
            </div>
            {/* <div className="flex">
              <input
                className="redeemCodeInput"
                name={this.textInput1}
                ref={this.textInput1}
                maxLength="4"
                onChange={e => this.handleInputCode1(e, this.textInput1)}
                onInput={this.toInputUppercase}
                placeholder="XXXX"
              />
              <div className="horizontalShortLine"></div>
              <input
                className="redeemCodeInput"
                name={this.textInput2}
                ref={this.textInput2}
                maxLength="4"
                onChange={e => this.handleInputCode2(e, this.textInput2)}
                onInput={this.toInputUppercase}
                placeholder="XXXX"
              />
              <div className="horizontalShortLine"></div>
              <input
                className="redeemCodeInput"
                name={this.textInput3}
                ref={this.textInput3}
                maxLength="4"
                onChange={e => this.handleInputCode3(e, this.textInput3)}
                onInput={this.toInputUppercase}
                placeholder="XXXX"
              />
              <div className="horizontalShortLine"></div>
              <input
                className="redeemCodeInput"
                name={this.textInput4}
                ref={this.textInput4}
                maxLength="4"
                onChange={e => this.handleInputCode4(e, this.textInput4)}
                onInput={this.toInputUppercase}
                placeholder="XXXX"
              />
              <button className="disableBtn" onClick={this.disableCode}>
                {localizationStrings.disableCode}
              </button>
            </div> */}
          </div>
        </form>

        <br />
        {this.state.validationMessageCode === 1 ? (
          <p
            style={{
              color: "green",
            }}
          >
            {this.handleValidationMessage(this.state.validationMessageCode)}
          </p>
        ) : (
          <p
            style={{
              display: this.state.redemptionCodeExist ? "none" : "block",
              color: "red",
            }}
          >
            {this.handleValidationMessage(this.state.validationMessageCode)}
          </p>
        )}

        <table
          className="redeemPageTable"
          style={{
            display: this.state.redemptionCodeExist ? "block" : "none",
          }}
        >
          <tbody>
            <tr>
              <th>Subscription Package:</th>
              <th>{this.state.validateCodePackage.package}</th>
            </tr>
            <tr>
              <th>Smart Padlocks:</th>
              <th>{this.state.validateCodePackage.maxLocks}</th>
            </tr>
            <tr>
              <th>User Accounts:</th>
              <th>{this.state.validateCodePackage.maxUsers}</th>
            </tr>
            <tr>
              <th>NFC Counts:</th>
              <th>{this.state.validateCodePackage.maxTags}</th>
            </tr>
            <tr>
              <th>Layer of Multi Approval:</th>
              <th>{this.state.validateCodePackage.maxMulti}</th>
            </tr>
          </tbody>
        </table>
        <br />
        <button
          className="redeemBtn"
          onClick={this.checkExistingAccount}
          style={{
            display: this.state.redemptionCodeExist ? "block" : "none",
          }}
        >
          {localizationStrings.redeem}
        </button>
        <p
          style={{
            marginTop: "20px",
            display: this.state.redemptionCodeExist ? "none" : "block",
          }}
        >
          {localizationStrings.noRedemptionMessage}
        </p>

        {/* <div className="flex" style={{ width: "100%", marginTop: "20px" }}>
          <img
            src={redemptionImages1}
            alt="redemptionImages1"
            style={{
              width: "500px"
            }}
          />
          <img
            src={redemptionImages2}
            alt="redemptionImages2"
            style={{
              width: "500px"
            }}
          />
        </div> */}
        <Modal
          show={this.state.showPopup}
          onHide={this.handlePopupClose}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.popupTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{this.state.popupImage}</Modal.Body>
        </Modal>
      </div>
    );
  }
}
export default Redemption;
